export default __webpack_public_path__ + "static/media/SmartSetup360DevPro.e43c4b65.png";